module.exports = __webpack_public_path__ + "img/card-contract-editor.111643a5.svg";